import { render, staticRenderFns } from "./ProjectTimeline.vue?vue&type=template&id=685fb9a4&scoped=true"
import script from "./ProjectTimeline.vue?vue&type=script&lang=js"
export * from "./ProjectTimeline.vue?vue&type=script&lang=js"
import style0 from "./ProjectTimeline.vue?vue&type=style&index=0&id=685fb9a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fb9a4",
  null
  
)

export default component.exports